import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs';

import { PortalRoutes } from '@app/app-routing.module';
import { AuthorizedDataService } from '@app/services/authorized-data/authorized-data.service';
import { Tracking } from '@app/services/tracking/tracking.service';
import { PortalTrackingEvents } from '@app/utils/tracking-events';

@Component({
  selector: 'client-travelers-page',
  templateUrl: './client-travelers-page.component.html',
  styleUrl: './client-travelers-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClientTravelersPageComponent implements OnInit {
  router = inject(Router);
  authDataService = inject(AuthorizedDataService);

  isLoading = true;

  authorisedData$ = this.authDataService.getAuthorizedData().pipe(
    tap((data) => {
      if (data) {
        this.isLoading = false;
      }
    }),
  );

  ngOnInit() {
    Tracking.track(PortalTrackingEvents.travelersPageOpened);
  }

  navigateToTraveler(id: string): void {
    void this.router.navigate([`/${PortalRoutes.Travelers}`, id]);
  }
}
